import { IntlShape } from 'react-intl';

export interface GroupedEntry {
  name: string;
  value: number;
  compareValue: number;
}

export type AggregationType = 'sum' | 'avg';

export function groupTopNWithOthers(
  entries: GroupedEntry[],
  maxGroups: number,
  intl: IntlShape,
  aggregationType: AggregationType = 'sum'
): GroupedEntry[] {
  const sorted = [...entries].sort((a, b) => b.value - a.value);
  const topGroups = sorted.slice(0, maxGroups);
  const others = sorted.slice(maxGroups);

  if (others.length > 0) {
    const totalValue = others.reduce((acc, curr) => acc + curr.value, 0);
    const totalCompareValue = others.reduce((acc, curr) => acc + curr.compareValue, 0);

    const othersCombined: GroupedEntry = {
      name: intl.formatMessage({
        id: 'groupby.others',
        defaultMessage: 'Others',
      }),
      value: aggregationType === 'avg' ? totalValue / others.length : totalValue,
      compareValue: aggregationType === 'avg' ? totalCompareValue / others.length : totalCompareValue,
    };

    return [...topGroups, othersCombined];
  }

  return topGroups;
}
